/**
 * 用户信息实体
 * zxw
 * 2024-01-20
 */
import React, { Component } from 'react';
import {
    Modal, Input, Row, Col, message,
    Radio, DatePicker, Select
} from 'antd';
import $ from 'jquery';
import { AddRequestHeaders, UjoinParams } from '../../incs/FunHelper';
import CNF from '../../incs/Config';

/** 
* 日期样式
*/
import locale from 'antd/es/date-picker/locale/zh_CN';
import 'dayjs/locale/zh-cn';
import dayjs from 'dayjs';

var date = new Date();
var month = date.getMonth() + 1;
var strDate = date.getDate();
if (month >= 1 && month <= 9) {
    month = '0' + month;
}
if (strDate >= 0 && strDate <= 9) {
    strDate = '0' + strDate;
}
const CURRENTDATE = date.getFullYear() + '-' + month + '-' + strDate;

const Option = Select.Option;
const { TextArea } = Input;

class Entity extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            ulid: '',
            orgStructuresLists: [],
        }
    }

    changeSex = (e) => { this.setState({ sex: e.target.value }); }
    changeIdcard = (e) => { this.setState({ idcard: e.target.value }); }
    changeBirthDate = (_, dateString) => { this.setState({ birthDate: dateString ? dateString : CURRENTDATE }); }
    changeEduBackgroup = (value) => { this.setState({ eduBackground: value }); }
    changeAbilityType = (value) => { this.setState({ abilityType: value }); }
    changeOrgInfoULID = (value) => {
        console.log('value', value);
        this.setState({ orgInfoULID: value });
        this.getOrgStructuresLists(value)
    }
    changeOrgStructureOrgULID = (value, params) => {
        this.setState({
            orgStructureOrgULID: value,
            sid: params.sid,
            orgStructureJobULID: '',
        });
    }
    changeOrgStructureJobULID = (value) => { this.setState({ orgStructureJobULID: value }); }
    changeAddress = (e) => { this.setState({ address: e.target.value }); }
    changeEntryDate = (date, dateString) => { this.setState({ entryDate: dateString ? dateString : CURRENTDATE }); }
    changeNumber = (e) => { this.setState({ number: e.target.value }); }
    changeDescription = (e) => { this.setState({ description: e.target.value }); }

    /**
     * 获取组织架构下拉列表
     */
    getOrgStructuresLists = (orgInfoULID) => {
        const _this = this;
        const params = {
            'rss': 'list',
            'org_info_ulid': orgInfoULID,
            'status': CNF.status[0].value,
        };
        $.ajax({
            url: `${CNF.api}org/structures${UjoinParams(params)}`,
            headers: AddRequestHeaders(),
            type: 'GET',
            dataType: 'JSON', success: function (data) {
                if (data.res === 0) {
                    if (data.dat.length > 0) {
                        _this.setState({ orgStructuresLists: data.dat })
                    }
                } else {
                    message.error(data.msg);
                }
            }
        })
    }

    update = () => {
        const _this = this;
        //  从身份证上获取出生年月
        var birthDate = this.state.idcard.substr(6, 4);      //  年
        birthDate += '-' + this.state.idcard.substr(10, 2);  //  月
        birthDate += '-' + this.state.idcard.substr(12, 2);  //  日

        //  执行修改
        $.ajax({
            url: `${CNF.api}user/infos/${this.state.ulid}`,
            headers: AddRequestHeaders(),
            type: 'PUT',
            dataType: 'JSON',
            data: JSON.stringify({
                // 'action': 'UPDATE_INFO',
                'sex': this.state.sex,
                'idcard': this.state.idcard,
                'birth_date': birthDate,
                'ability_type': this.state.abilityType,
                'edu_background': this.state.eduBackground,
                'org_info_ulid': this.state.orgInfoULID,
                'org_structure_org_ulid': this.state.orgStructureOrgULID,
                'org_structure_job_ulid': this.state.orgStructureJobULID,
                'address': this.state.address,
                'entry_date': this.state.entryDate,
                'leave_date': this.state.leaveDate,
                'number': this.state.number,
                'description': this.state.description,
            }), success: function (data) {
                if (data.res === 0) {
                    message.success(data.msg, 1);
                    setTimeout(function () {
                        _this.cancel();
                        _this.props.isRefresh();
                    }, 1500);
                } else {
                    message.error(data.msg, 1.5);
                    _this.setState({ loading: false });
                }
            }
        });
    }

    ok = () => {
        if (!this.state.sex) {
            message.error('性别不可为空！', 1);
            return;
        }
        if (!this.state.idcard) {
            message.error('身份证号不可为空！', 1);
            return;
        }
        var rex = /^(\d{15}$|^\d{18}$|^\d{17}(\d|X|x))$/;
        if (!rex.test(this.state.idcard)) {
            message.error('身份证号格式错误！', 1);
            return;
        }
        if (!this.state.abilityType) {
            message.error('能力类型不可为空！', 1);
            return;
        }
        if (!this.state.eduBackground) {
            message.error('学历不可为空！', 1);
            return;
        }
        this.setState({ loading: true });
        if (this.props.record) {
            this.update();
        } else {
            this.create();
        }
    };

    cancel = () => {
        this.props.setIsModalOpen(false);
        this.setState({
            loading: false,
            ulid: '',
        });
    }

    componentDidUpdate() {
        if (this.props.record && this.state.ulid !== this.props.record.key) {
            this.setState({
                record: this.props.record,
                displayname: this.props.record.displayname,
                ulid: this.props.record.key,
                sex: this.props.record.sex ? this.props.record.sex : CNF.sexs[0].value,
                idcard: this.props.record.idcard ? this.props.record.idcard : '',
                birthDate: this.props.record.birth_date ? this.props.record.birth_date : CURRENTDATE,
                abilityType: this.props.record.ability_type ? this.props.record.ability_type : CNF.abilityTypes[0].value,
                eduBackground: this.props.record.edu_background ? this.props.record.edu_background : CNF.eduBackgrounds[0].value,
                orgInfoULID: this.props.record.org_info_ulid ? this.props.record.org_info_ulid : '',
                orgStructureOrgULID: this.props.record.org_structure_org_ulid ? this.props.record.org_structure_org_ulid : '',
                orgStructureJobULID: this.props.record.org_structure_job_ulid ? this.props.record.org_structure_job_ulid : '',
                address: this.props.record.address,
                entryDate: this.props.record.entry_date ? this.props.record.entry_date : CURRENTDATE,
                leaveDate: this.props.record.leave_date ? this.props.record.leave_date : CURRENTDATE,
                description: this.props.record.description,
            });
            //  切换公司时调用
            if (this.state.orgInfoULID !== this.props.record.org_info_ulid) {
                this.getOrgStructuresLists(this.props.record.org_info_ulid);
            }
        }
    }

    render() {
        return (
            <div>
                <Modal
                    width={700}
                    title={'修改用户信息：' + this.state.displayname}
                    open={this.props.isModalOpen}
                    onOk={this.ok}
                    onCancel={this.cancel}
                    keyboard={true}
                    okText='确认'
                    cancelText='取消'
                    okButtonProps={{ disabled: this.state.loading }}
                >
                    <Row style={{ marginTop: 10 }}>
                        <Col span={3} style={{ lineHeight: 2.2 }}>性别：</Col>
                        <Col span={8}>
                            <Radio.Group onChange={this.changeSex} value={this.state.sex}>
                                {
                                    CNF.sexs && CNF.sexs.map((item) => {
                                        return <Radio key={item.value} value={item.value}>{item.key}</Radio>
                                    })
                                }
                            </Radio.Group>
                        </Col>
                        <Col span={3} offset={2} style={{ lineHeight: 2.2 }}>身份证号：</Col>
                        <Col span={8}>
                            <Input
                                value={this.state.idcard}
                                placeholder='必填'
                                style={{ width: '100%' }}
                                onChange={this.changeIdcard}
                                disabled={this.state.loading}
                            />
                            {/* <DatePicker 
                                onChange={this.changeBirthDate}
                                placeholder='请选择日期' 
                                value={dayjs(this.state.birthDate, 'YYYY-MM-DD')}
                                style={{ width: '100%' }}
                                locale={locale}
                                disabled={this.state.loading}
                            /> */}
                        </Col>
                    </Row>
                    <Row style={{ marginTop: 10 }}>
                        <Col span={3} style={{ lineHeight: 2.2 }}>学历：</Col>
                        <Col span={8}>
                            <Select
                                value={this.state.eduBackground}
                                style={{ width: '100%' }}
                                onChange={this.changeEduBackgroup}
                                disabled={this.state.loading}
                            >
                                {
                                    CNF.eduBackgrounds && CNF.eduBackgrounds.map((item) => {
                                        return <Option key={item.value} value={item.value}>{item.key}</Option>
                                    })
                                }
                            </Select>
                        </Col>
                        <Col span={3} offset={2} style={{ lineHeight: 2.2 }}>能力类型：</Col>
                        <Col span={8}>
                            <Select
                                value={this.state.abilityType}
                                style={{ width: '100%' }}
                                onChange={this.changeAbilityType}
                                disabled={this.state.loading}
                            >
                                {
                                    CNF.abilityTypes && CNF.abilityTypes.map((item) => {
                                        return <Option key={item.value} value={item.value}>{item.key}</Option>
                                    })
                                }
                            </Select>
                        </Col>
                    </Row>
                    <Row style={{ marginTop: 10 }}>
                        <Col span={3} style={{ lineHeight: 2.2 }}>入职日期：</Col>
                        <Col span={8}>
                            <DatePicker
                                onChange={this.changeEntryDate}
                                placeholder='请选择日期'
                                value={dayjs(this.state.entryDate, 'YYYY-MM-DD')}
                                style={{ width: '100%' }}
                                locale={locale}
                                disabled={this.state.loading}
                            />
                        </Col>
                        <Col span={3} offset={2} style={{ lineHeight: 2.2 }}>员工编号：</Col>
                        <Col span={8}>
                            <Input
                                value={this.state.number}
                                style={{ width: '100%' }}
                                onChange={this.changeNumber}
                                disabled={this.state.loading}
                            />
                        </Col>
                    </Row>
                    <Row style={{ marginTop: 10 }}>
                        <Col span={3} style={{ lineHeight: 2.2 }}>公司：</Col>
                        <Col span={21}>
                            <Select value={this.state.orgInfoULID}
                                style={{ width: '100%' }}
                                onChange={this.changeOrgInfoULID}
                                disabled={this.state.loading}
                            >
                                <Option key='请选择公司' value=''>请选择公司</Option>
                                {
                                    this.props.orgInfosLists && this.props.orgInfosLists.length && this.props.orgInfosLists.map((item) => {
                                        return <Option key={item['ulid']} value={item['key']}>{item['name']}</Option>
                                    })
                                }
                            </Select>
                        </Col>
                    </Row>
                    <Row style={{ marginTop: 20 }}>
                        <Col span={3} style={{ lineHeight: 2.2 }}>部门：</Col>
                        <Col span={8}>
                            <Select
                                value={this.state.orgStructureOrgULID}
                                style={{ width: '100%' }}
                                onChange={this.changeOrgStructureOrgULID}
                                disabled={this.state.loading}
                            >
                                <Option key='部门' value=''>请选择部门</Option>
                                {
                                    this.state.orgStructuresLists && this.state.orgStructuresLists.length && this.state.orgStructuresLists.map((item) => {
                                        //  决策类和组织类
                                        if (parseInt(item['org_function_type']) !== parseInt(CNF.orgFunctionTypes[2].value)) {
                                            return <Option key={item['ulid']} sid={item['sid']} value={item['ulid']}>{item['title']}</Option>
                                        }
                                        return null;
                                    })
                                }
                            </Select>
                        </Col>
                        <Col span={3} offset={2} style={{ lineHeight: 2.2 }}>所属岗位：</Col>
                        <Col span={8}>
                            <Select
                                value={this.state.orgStructureJobULID}
                                style={{ width: '100%' }}
                                onChange={this.changeOrgStructureJobULID}
                                disabled={this.state.loading}
                            >
                                <Option key='岗位' value=''>请选择岗位</Option>
                                {
                                    this.state.orgStructuresLists && this.state.orgStructuresLists.length && this.state.orgStructuresLists.map((item) => {
                                        //  岗位类
                                        if (parseInt(item['org_function_type']) === parseInt(CNF.orgFunctionTypes[2].value)) {
                                            if (this.state.sid) {
                                                return this.state.sid === item['up_sid'] ? <Option key={item['ulid']} value={item['ulid']}>{item['title']}</Option> : null;
                                            }
                                            return <Option key={item['ulid']} value={item['ulid']}>{item['title']}</Option>
                                        }
                                        return null;
                                    })
                                }
                            </Select>
                        </Col>
                    </Row>
                    <Row style={{ marginTop: 10 }}>
                        <Col span={3} style={{ lineHeight: 2.2 }}>住址：</Col>
                        <Col span={21}>
                            <Input
                                value={this.state.address}
                                style={{ width: '100%' }}
                                onChange={this.changeAddress}
                                disabled={this.state.loading}

                            />
                        </Col>
                    </Row>
                    <Row style={{ marginTop: 10 }}>
                        <Col span={3} style={{ lineHeight: 2.2 }}>备注：</Col>
                        <Col span={21}>
                            <TextArea
                                placeholder="备注可写在这里..."
                                autosize={{ minRows: 3, maxRows: 3 }}
                                onChange={this.changeDescription}
                                disabled={this.state.loading}
                                value={this.state.description}
                            />
                        </Col>
                    </Row>
                </Modal>
            </div>
        );
    }
}

export default Entity